/** */
import cx from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import Breadcrumbs from 'app/shared/breadcrumbs/breadcrumbs';

import { Icon } from 'assets/icons';
import styles from './header.module.css';

const MemberAreaHeader = ({ onHamburgerClick }) => {
  const { page_title } = useSelector((state) => state.header);

  return (
    <header className={cx(styles.wrapper)}>
      <div>
        <div>
          <span className={styles.menuIcon} onClick={onHamburgerClick}>
            <Icon name="menu" />
          </span>

          {page_title?.length && (
            <span className={styles.title}>
              <Breadcrumbs crumbs={page_title} />
            </span>
          )}
        </div>
      </div>
    </header>
  );
};

export default MemberAreaHeader;
